<template>
  <div>
    <span id="center-text">{{ getPercentString() }}</span>
    <GChart
      :settings="{packages: ['corechart']}"
      :version="'42'"
      :createChart="createChart"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
// eslint-disable-next-line no-unused-vars
import PieChart from '../features/reports/common/PieChart'

export const allColors = [
  '#dbdee5', '#2ec4b6'
]

export default {
  name: 'BaseProgressRing',
  components: {
    GChart
  },
  props: {
    current: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    allColors: {
      type: [Array, Boolean],
      default: false
    }
  },
  data () {
    return {
      chartData: this.prepareDateByType(),
      google: null,
      el: null
    }
  },
  watch: {
    allColors: {
      handler () {
        const value = this.prepareDateByType()
        this.chartData = { data: value.data, colorSchema: value.colorSchema }
        this.createChart(this.el, this.google)
      },
      deep: true
    },
    current () {
      this.handlePercentChange()
    },
    total () {
      this.handlePercentChange()
    }
  },
  methods: {
    /**
     * Preparing chart data  according to
     * {@link https://developers.google.com/chart/interactive/docs/datatables_dataviews#arraytodatatable}
     * @returns {data:  {data: array of chart data, colorSchema: array of colors} }
     */
    getPercentString () {
      if (this.current === this.total || this.total === 0) {
        return '100%'
      } else if ((this.current / this.total * 100).toFixed(2) === '100.00') {
        return '99.99%'
      } else {
        return `${(this.current / this.total * 100).toFixed(2)}%`
      }
    },
    handlePercentChange () {
      const value = this.prepareDateByType()
      this.chartData = { data: value.data, colorSchema: value.colorSchema }
      this.createChart(this.el, this.google)
    },
    prepareDateByType () {
      const header = [ 'Label', 'Percent' ]
      const result = []
      result.push(['Part', this.current])
      result.push(['Leftover', this.total - this.current])
      // this.list.forEach(item => result.push([ item.name, item.value ]))
      result.unshift(header)
      return {
        data: result,
        colorSchema: (this.allColors || allColors).slice(0, result.length)
      }
    },
    /**
     * Callback for createChart property of vue-google-charts library
     * all list of available options {@see https://developers.google.com/chart/interactive/docs/gallery/piechart#configuration-options}
     * prepared data passed into chat using DataView {@link https://developers.google.com/chart/interactive/docs/datatables_dataviews}
     * @param el - chart html element
     * @param google - link to the Google Chart library
     */
    createChart (el, google) {
      if (!this.google) {
        this.google = google
        this.el = el
      }
      const data = google.visualization.arrayToDataTable(this.chartData.data)
      const view = new google.visualization.DataView(data)
      const options = {
        reverseCategories: true,
        legend: 'none',
        backgroundColor: 'transparent',
        axisFontSize: 0,
        chartArea: { width: '100%', height: '100%' },
        pieHole: 0.8,
        label: 'none',
        height: 50,
        width: 50,
        pieSliceText: 'none',
        tooltip: { trigger: 'none' },
        colors: this.chartData.colorSchema,
        enableInteractivity: false
      }

      try {
        let chart = new google.visualization.PieChart(el)
        chart.draw(view, options)
        /* to prevent unexpected interaction by click on chart */
        google.visualization.events.addListener(chart, 'select', () => {
          chart.setSelection(null)
        })
        /* to prevent show errors on chart */
        google.visualization.events.addListener(chart, 'error', function (err) {
          console.log('error', err)
        })
      } catch (e) {
        console.log(e, el)
      }
    }
  }
}

</script>

<style scoped lang="scss">
  #center-text {
    position: absolute;
    font-weight: 500;
    font-size: 12px;
  }
</style>
